import React from "react";
import {useTranslation} from "react-i18next";
import PageHeading from "../../organisms/pageHeading/pageHeading";
import NavigationButton from "../../atoms/button/navigationButton";
import {IconSource} from "../../../shared/enums/iconSource";
import {observer} from "mobx-react-lite";
import "./specialDaysHeader.sass";
import {useHistory} from "react-router";
import {Navigation} from "../../../utils/navigation";
import {RoutePaths} from "../../../shared/routePaths";
import {useStores} from "../../../stores/useStores";
import ButtonIcon from "../../atoms/button/buttonIcon";

const SpecialDaysHeader: React.FC = () => {
  const history = useHistory();
  const {t} = useTranslation(["translation", "specialDays"]);
  const {
    uiStore: {occasionUiStore}
  } = useStores();

  return (
    <>
      <div className="special-days-header">
        <PageHeading
          title={t("translation:titles.specialDays")}
          actionTitle={t("specialDays:labels.addNew")}
          actionIcon={IconSource.add}
          onActionClicked={() =>
            Navigation.go(history, RoutePaths.SpecialDaysCreate)
          }
        />
      </div>
      <div className="special-days-navigator">
        <div>
          <ButtonIcon
            type="secondary"
            onClick={() => {
              occasionUiStore.updateCalendarYear(new Date().getFullYear());
            }}
          >
            {t("translation:time.thisYear")}
          </ButtonIcon>
          <NavigationButton
            icon={IconSource.leftArrow}
            tooltip={t("event:labels.calendar.previous")}
            onClick={() =>
              occasionUiStore.updateCalendarYear(
                occasionUiStore.calendarYear - 1
              )
            }
          />

          <NavigationButton
            icon={IconSource.rightArrow}
            tooltip={t("event:labels.calendar.next")}
            onClick={() =>
              occasionUiStore.updateCalendarYear(
                occasionUiStore.calendarYear + 1
              )
            }
          />

          <div>{occasionUiStore.calendarYear}</div>
        </div>
      </div>
    </>
  );
};

export default observer(SpecialDaysHeader);
